'use strict';

angular.module('enervexSalesappApp').factory('TabularDuctData', function ($resource) {
	return $resource('/api/tabular-duct-data/:id', {
		id: '@_id'
	},
	{
		update: {
			method: 'PUT'
		}
	});
});
